import { render, staticRenderFns } from "./dispute.vue?vue&type=template&id=1caca922&scoped=true&"
import script from "./dispute.vue?vue&type=script&lang=js&"
export * from "./dispute.vue?vue&type=script&lang=js&"
import style0 from "./dispute.vue?vue&type=style&index=0&id=1caca922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caca922",
  null
  
)

export default component.exports